import TeamsListSection from "../components/TeamsListSection";
import { useAuth } from "../hooks/useAuth";

export default function Teams() {
  const { user } = useAuth();

  return (
    <div className="flex grow flex-col items-center">
      {/* Teams */}
      <div className="flex mt-10 w-full lg:w-3/4">
        <TeamsListSection />
      </div>
    </div>
  );
}
